module.exports = __webpack_public_path__ + "img/zizhi.3f4b3787.png";